<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table (detail)="onDetail($event)" (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns"
                  [dataProvider]="angieScreensService" [title]="title" [searchColumns]="searchColumns"></data-table>
</page-content>
